import { RegisterClass } from "core/Misc/typeStore";
import { Quaternion, Vector3 } from "core/Maths/math.vector";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphBuildState } from "../rewardGraphBuildState";

export class RewardRotateBlock extends RewardGraphNode {
    public constructor(name: string) {
        super(name);

        this.registerInput("left", RewardGraphConnectionPointTypes.AutoDetect);
        this.registerInput("right", RewardGraphConnectionPointTypes.AutoDetect);

        this.registerOutput("output", RewardGraphConnectionPointTypes.BasedOnInput);

        this.output._typeConnectionSource = this.left;

        this.left.excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.PartID);
        this.left.excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.Float);
        this.left.excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.Boolean);
        this.right.excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.PartID);
        this.right.excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.Float);
        this.right.excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.Boolean);
        this.right.excludedConnectionPointTypes.push(RewardGraphConnectionPointTypes.Vector3);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardRotateBlock";
    }

    /**
     * Gets the left input component
     */
    public get left(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    /**
     * Gets the right input component
     */
    public get right(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    /**
     * Gets the reward output component
     */
    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        let func: (state: RewardGraphBuildState) => any;
        const left = this.left;
        const right = this.right;

        if (!left.isConnected || !right.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        const rotateQuat = left.type === RewardGraphConnectionPointTypes.Quat;

        if( rotateQuat ) {
            func = (state) => {
                return (left.getConnectedValue(state) as Quaternion).multiply(right.getConnectedValue(state))
            }
        } else {
            func = (state) => {
                const rotation = right.getConnectedValue(state) as Quaternion;
                const vector = left.getConnectedValue(state) as Vector3;
                const rotated =  vector.applyRotationQuaternion(rotation);
                return rotated;
            }
        }

        this.output._storedFunction = (state) => {
            return func(state);
        };
    }
}

RegisterClass("MELS.RewardRotateBlock", RewardRotateBlock);
